<template>
  <v-btn
    v-if="render"
    v-bind="$attrs"
    color="primary"
    href="/billing"
  >
    {{ $t('Upgrade Team') }}
  </v-btn>
</template>

<script>
export default {
  computed: {
    render() {
      return this.$page.props.user.current_team.owned_by_user && (
        this.$page.props.user.current_team.plan === 'Personal' ||
        this.$page.props.user.current_team.plan === 'Collaborate'
      );
    }
  },
}
</script>